<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button class="btn-primary" size="small" icon="el-icon-plus" @click="showDialog(2)" v-if="permission.add">{{ permission.add }}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="clientList" border style="width: 100%">
                <el-table-column width="80px" prop="Contactor" label="联系人" show-overflow-tooltip></el-table-column>
                <el-table-column width="110px" prop="PhoneNum" label="电话号码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Tags" label="地址标签" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Province" label="省" show-overflow-tooltip></el-table-column>
                <el-table-column prop="City" label="市" show-overflow-tooltip></el-table-column>
                <el-table-column prop="District" label="区" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Addr" label="详细地址" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="是否默认">
                    <template slot-scope="scope">{{ scope.row.IsDefault | booleanHandle }}</template>
                </el-table-column>
                <el-table-column prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="80px" prop="Updator" label="更新人" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="120px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button size="mini" @click="editAddress(scope.row)" v-if="permission.edit">
                                <i class="el-icon-edit-outline"></i>
                            </el-button>
                            <el-button size="mini" type="danger" @click="delAddress(scope.row)" v-if="permission.del">
                                <i class="el-icon-delete"></i>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" :title="dialogTitle" :before-close="clearDialog" :visible.sync="dialogVisible" custom-class="base-dialog" width="800px">
                <div class="dialog-content" v-if="dialogVisible">
                    <addAddress
                        ref="addAddress"
                        :submitType="submitType"
                        :addrData="this.formData"
                        :areaSelect="this.areaSelect"
                        @resetData="clearDialog"
                        @loadData="loadData"
                    ></addAddress>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import addAddress from '@/components/common/addAddress';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        addAddress,
        breadcrumb,
        elTableColumn
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            submitType: 1, // 1 添加 2 修改
            booleanTrue: true,
            booleanFalse: false,
            EntpId: userMsg.EntpId,
            areaSelect: [], // 地址三级联动
            dialogVisible: false,
            dialogTitle: '编辑地址', //dialog标题
            searchData: {
                EntpId: userMsg.EntpId,
                page: 1, // 当前页数
                limit: 15, // 每页限制条数
                key: '' //关键字查询
            },
            formData: {},
            clientList: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('AddressManage');
    },
    methods: {
        loadData() {
            this.getTableData();
            this.clearDialog();
        },
        changeData(type, data) {
            if (type == 1) {
                this.clientList.unshift(data);
            }
        },
        clearDialog() {
            this.$refs.addAddress.resetForm();
            this.dialogVisible = false;
            this.formData = {};
            // this.areaSelect = []
        },
        // 获取数据
        getTableData() {
            this.dialogVisible = false;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAddressList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.clientList = data;
                    this.tableDataLength = res.count;
                });
        },
        // 编辑地址
        editAddress(data) {
            this.submitType = 2;
            this.formData = data;
            this.areaSelect = [data.Province, data.City, data.District];
            this.dialogVisible = true;
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        // 显示dialog
        showDialog() {
            this.submitType = 1;
            this.formData = {};
            this.areaSelect = [];
            this.dialogVisible = true;
        },
        // 删除地址
        delAddress(data) {
            let that = this;
            if (data.IsDefault) {
                this.$util.warningMsg('默认地址不能删除');
                return;
            }
            this.$util.elConfirm({
                content: '确定要删除该地址吗？',
                confirm() {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DeleteAddress',
                            data: {
                                AddrId: data.Id,
                                Uid: that.EntpId
                            }
                        })
                        .then(() => {
                            that.getTableData();
                        });
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    max-height: 800px;
}
.base-content {
    max-width: 1200px;
    margin: 0 auto;
}
</style>
